export default __webpack_public_path__ + "static/media/gallery_07.73c7c2d6.jpg";